import { useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { hasPrivilege } from "../api/token";
import RouterCard from "../components/RouterCard";

function RouterAssign() {
  const navigate = useNavigate();
  const params = useParams();
  const assign = hasPrivilege('assign');

  useEffect(() => {
    if (!assign) {
      navigate("/");
    }
  }, [navigate, assign])

  if (assign) {
    return <RouterCard ident={params.id} editable={true} layer="assign" />;
  }
}

export default RouterAssign;
